import { isTextualBlockToggleAllowed } from '@lumapps/wrex-textual-block/utils/isTextualBlockToggleAllowed';
import type { TypographyEditor } from '@lumapps/wrex-typography/types';
import { isParagraph } from '@lumapps/wrex-typography/utils/isParagraph';
import type { WrexEditor } from '@lumapps/wrex/types';

import type { CodeBlockEditor } from '../types';
import { isCodeBlock } from './isCodeBlock';

export const isCodeBlockAllowed = (editor: WrexEditor<CodeBlockEditor & TypographyEditor>): boolean =>
    isTextualBlockToggleAllowed(editor, { isBlock: isCodeBlock, canToggleFrom: isParagraph });
